module.exports = __webpack_public_path__ + "static/media/10-web-or-mls-DSC06532.0cccbdcf.jpg";